module.exports = __webpack_public_path__ + "img/usjt.41ea9e7a.svg";